import { render, staticRenderFns } from "./period-selector.vue?vue&type=template&id=4c7e03c9&"
import script from "./period-selector.vue?vue&type=script&lang=js&"
export * from "./period-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports